/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Buffer } from 'buffer';

import { Endpoint } from '../index';
import { z } from '../zod';

export const UserThumbnailGet = {
  id: 'user.thumbnail.get',
  tag: 'User',
  summary: 'Get users thumbnail',
  description: 'Get users thumbnail',
  method: 'get',
  flags: { isAuthorized: true },
  route: () => `/user/thumbnail`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.instanceof(Buffer),
        },
      },
    },
  },
} as const satisfies Endpoint;
